export default __webpack_public_path__ + "static/media/custom_text.0fded7bd.jpg";